import cx from 'helpers/cx'

import styles from './Show.module.css'
import type { Breakpoint, ShowProps } from './Show.types'

const fromClassNames: Record<Breakpoint, string> = {
    mobileLandscape: styles.fromMobileLandscape,
    tablet: styles.fromTablet,
    desktop: styles.fromDesktop,
    desktopLg: styles.fromDesktopLg,
    desktopXl: styles.fromDesktopXl,
}

const untilClassNames: Record<Breakpoint, string> = {
    mobileLandscape: styles.untilMobileLandscape,
    tablet: styles.untilTablet,
    desktop: styles.untilDesktop,
    desktopLg: styles.untilDesktopLg,
    desktopXl: styles.untilDesktopXl,
}

/**
 * Shows its children only within a range of screen widths, using CSS media
 * queries. The children are always rendered; CSS hides them outside the range.
 */
export const Show = ({ from, until, children }: ShowProps) => (
    <div
        className={cx(
            styles.show,
            from && fromClassNames[from],
            until && untilClassNames[until],
        )}
    >
        {children}
    </div>
)
